export default function useXcdnImage(url: string, parameters: string, seo: string): string {
  if (!url) {
    return ''
  }

  let urlObj: URL

  try {
    urlObj = new URL(url)
  }
  catch (e) {
    console.error('useXcdnImage - Invalid URL:', url, e)
    return url
  }

  seo = stringToSlug(seo || '')

  let paramKey = 'f'

  if (urlObj.search) {
    const urlParameters = urlObj.search.replace('?', '')
    parameters = parameters ? parameters + '&' + urlParameters : urlParameters
    urlObj.search = ''
  }

  const searchParams = new URLSearchParams(parameters)
  let xcdnParam = searchParams.get('sf') || searchParams.get('f') || ''
  searchParams.delete('f')
  searchParams.delete('sf')

  // q:100 // quality when set to 0, xcdn's default quality is applied which equals to 80
  // if(!xcdnParam?.includes('q:')) {
  //   xcdnParam = xcdnParam + (xcdnParam ? '/q:100' : 'q:100')
  // }

  // sm:1 // strip metadata
  if (!xcdnParam?.includes('sm:')) {
    xcdnParam = xcdnParam + (xcdnParam ? '/sm:1' : 'sm:1')
  }

  // scp:1 // strip colorprofile
  if (!xcdnParam?.includes('scp:')) {
    xcdnParam = xcdnParam + (xcdnParam ? '/scp:1' : 'scp:1')
  }

  if (urlObj.pathname.includes(seo) && urlObj.search.includes(parameters)) {
    return urlObj.toString()
  }

  if (seo) {
    const parts = urlObj.pathname.split('.')
    const extension = parts.pop()
    paramKey = 'sf'
    urlObj.pathname = parts.join('.') + '/' + seo + '.' + extension
  }

  searchParams.set(paramKey, xcdnParam)
  urlObj.search = searchParams?.toString()

  return urlObj.toString()
}
